import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";

import {
  getPartialSitemap,
  getUserPreferences,
  userPreferencesQuery,
} from "@pm2/api";
import { pm2SitemapStore } from "@pm2/sitemap-utils";
import { pm2ConfigStore } from "@pm2/store";
import { userIdentityStore } from "@provider/user-identity";

export function useAppPropsRevalidation(path: string): void {
  const queryClient = useQueryClient();
  const userPreferencesQueryKey = userPreferencesQuery.useQueryKey();

  const previewMode = pm2ConfigStore.useSelector((state) => state.previewMode);
  const portalConfig = pm2ConfigStore.useSelector((state) => state.config);

  const sitemapDispatch = pm2SitemapStore.useDispatch();

  // fetch the user's current preferences
  useEffect(() => {
    let isActive = true;

    const userId = userIdentityStore.getState().user?.id;

    if (!userId) {
      return;
    }

    getUserPreferences(userId).then((preferences) => {
      if (!isActive) {
        return;
      }

      queryClient.setQueryData(userPreferencesQueryKey, preferences ?? null);
    });

    return () => {
      isActive = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryClient, userPreferencesQueryKey.join("-")]);

  // revalidate partial sitemap with user specific privileges in mind
  useEffect(() => {
    let isActive = true;

    Promise.resolve(
      getPartialSitemap(portalConfig, path, {
        previewMode,
      }),
    )
      .then((partialSitemap) => {
        if (!isActive) {
          return;
        }

        sitemapDispatch(
          pm2SitemapStore.actions.updatePartialSitemap(partialSitemap),
        );
      })
      .catch((reason) => {
        console.error("unable to init clientside:", reason);
        alert("Der opstod en fejl ved indlæsning af portalen, vi beklager.");
      });

    return () => {
      isActive = false;
    };
  }, [path, portalConfig, previewMode, sitemapDispatch]);
}
